.inbox-rich-text-input-container {
    composes: textfield-container from '../../../textfield/textfield.module.css';
    min-height: 0;
    max-height: 300px;
    padding: 0;
    cursor: text;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
}

.inbox-rich-text-input-container > div {
    min-height: 0;
    flex: 1;
    overflow-y: visible;
}

.inbox-rich-text-input-container :global(.ql-editor) {
    min-height: 104px;
    padding: 12px 16px !important;
    font-size: var(--font-small);
    max-height: 200px;
    overflow-y: scroll !important;
    scrollbar-width: none;
}

.inbox-rich-text-input-container :global(.ql-container.ql-snow) {
    border: none;
}

.inbox-rich-text-input-container :global(.ql-editor.ql-blank::before) {
    left: 16px !important;
}

.inbox-rich-text-input-container :global(.ql-mention-list-container) {
    bottom: 100% !important;
}

.inbox-rich-text-input-container.note-mode {
    background-color: var(--tag-yellow-lt);
}

.selector-header {
    display: flex;
    width: fit-content;
    max-width: 100%;
    min-height: 28px !important;
    flex: 0 0 auto;
    overflow: visible !important;
}

.footer-container {
    position: absolute;
    bottom: 5px;
    right: 6px;
    z-index: 1000;
}
